module.exports = __webpack_public_path__ + "0c3e52af807b843853a0a8745171a8b0.pdf";